let useProxy = process.env.REACT_APP_ADM_USE_PROXY || false;
useProxy = useProxy === "true" ? true : false;
export default {
  USE_PROXY: useProxy,
  API_BASE: process.env.REACT_APP_ADM_API_BASE || "https://admin.admediary.com",
};
